<script>
  import { afterUpdate, onMount } from "svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import Dropdown from "./Components/numberDropdown.svelte"
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../Script/queryString"
  import Pagination from "./Components/pagination.svelte"
  import ReleaseData from "../../Pages/History/PendingDocument/Stores/releaseDoc"
  import ApplicationState from "../../Stores/applicationStates"
  import FilterComponent from "../../Pages/History/Document/Components/filterComponent.svelte"
  export let filetemplate = false
  /**
   * @type {HTMLElement} filter component stored
   */
  export let filterComponent = FilterComponent
  /**
   * @type {Boolean} whether to enable checkbox input in a list or not
   */
  export let disableGroupCheckBox = false

  /**
   * @type {Boolean} whether to enable a name sort btn or not
   */
  export let nameSort = true
  /**
   * @type {String} table title value
   */
  export let title = ""
  /**
   * @type {Object} table list data
   */
  export let jsonData
  /**
   * @type {Boolean} whether to show a filter component or not
   */
  export let filter = false
  /**
   * @type {Boolean} whether to show a search input in a filter component or not
   */
  export let search = true
  /**
   * @type {Boolean} whether to show a which parameter going to be searched a filter component or not
   */
  export let searchparam = true
  /**
   * @type {Boolean} whether to enable a date sort btn or not
   */
  export let dateSort = true
  /**
   * @type {Boolean} overall document count for showing pagination
   */
  export let count

  /**
   * @type {Boolean}  to show all, active, pending, revoked status selection in filter component
   */
  export let status = true
  /**
   * @type {Boolean}  to show all, single, bulk mode section in filter component
   */
  export let mode = false
  /**
   * @type {Boolean}  to show pending status section in filter component
   */
  export let bulkStatus = false

  /**
   * @type {Boolean}  whether to show a release a button or not (pending document)
   */
  export let showReleaseBtn = false

  /**
   * @type {Number} - active page number
   */
  export let activePage = 1

  // export let colorInfo = false
  /**
   * @type {Array<Number>} - entry list in dropdown list
   */
  export let entriesList = [10, 50, 100]

  export let infoDetails = {}

  /**
   * @type {Object} - object get from window location
   */
  let query
  /**
   * @type {String} - which parameter need to search
   */
  let searchParam = "name"

  /**
   * @type {Boolean} - in DAC after filted this variable handle some conponents show and hidden state.
   */
  let searched = false

  /**
   * @type {Boolean} - controls the show or hide the FilterForm.
   */
  let showFilterForm = false

  /**
   * @type {Number} - how many list need to show
   */
  let entries = entriesList[0]

  /**
   * @type {Array<jsonData>} - it consists of filtered json list. It displayed in list.
   */
  let sortData = []

  /**
   * @type {Number} - which sory type need to show (date or name)
   */
  let sortBy

  /**
   * @type {Number} - how many pages for the overall list
   */
  let maxPage

  /**
   * @type {Number} - sort lists ascending or descending
   */
  let sort

  /**
   * @type {Boolean} - sort icon ascending or descending using date
   */
  let sortByDateFile

  /**
   * @type {Boolean} - sort icon ascending or descending using name
   */
  let sortByNameFile = true

  /**
   * @type {String} - find list in search method using this string
   */
  let searchvalue

  /**
   * @type {String} - filter components paramaters
   */
  let filterParameters = {
    search: {
      searchParam: "name",
    },
    date: {},
  }
  /**
   * @typedef {Object} notificationSelectAll
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notificationSelectAll}
   */
  let notificationSelectAll = {
    close() {},
  }

  let showInfo = false

  /**
   * initial list created
   */
  onMount(async () => {
    query = queryStringToJSON($querystring)
    entries = query.limit ? query.limit : entriesList[0]
    activePage = query.page ? query.page : 1
    sortByDateFile = query.sort == 1 ? true : false
    sortByNameFile = query.sort == 1 ? true : false
    sort = query.sort == 1 ? true : false
    searchParam = query.sin ? query.sin : "name"
    searchvalue = query.sname ? query.sname : ""
    listEntries(entries)
  })

  //call listEntries Function while entries value changed
  $: if (jsonData) listEntries(entries)

  /**
   * @description function for count a max page assign what are list need to show
   * @function listEntries
   */
  const listEntries = (entries) => {
    console.log(count/ Number(entries));
    
    // Calculate the maximum number of pages based on the length of jsonData and the number of entries per page
    maxPage = Math.ceil(count / Number(entries))
    sortData = jsonData
  }

  /**
   * @description function for sort list ascending or descending based on name
   * @function toggleSortByName
   */
  const toggleSortByName = () => {
    query.sortBy = "name"
    searched = false
    sortBy = "name"
    sortByNameFile = !sortByNameFile
    sort = sortByNameFile
    console.log("sortByName");
    dispatch("changeEntries", { filter: filterParameters, entries: entries, activePage: activePage, sort: sort ? 1 : -1, sortBy: "name" })
  }

  /**
   * @description function for sort list ascending or descending based on date
   * @function toggleSortByDate
   */
  const toggleSortByDate = () => {
    query.sortBy = "date"
    searched = false
    sortBy = "date"
    sortByDateFile = !sortByDateFile
    sort = sortByDateFile
    console.log("sortByDate");
    dispatch("changeEntries", { filter: filterParameters, entries: entries, activePage: activePage, sort: sort ? 1 : -1, sortBy: "date" })
  }

  /**
   * @description function for search list using id
   * @function filterList
   */
  const filterList = (e) => {
    filterParameters = e.detail
    showFilterForm = false
    activePage = 1
    console.log("filterList");
    dispatch("changeEntries", { filter: filterParameters, entries: entries, activePage: 1, sort: sort ? 1 : -1, sortBy: sortBy })
  }

  /**
   * @description function for releasing selected documents
   * @function releaseSelectedEntries
   */
  const releaseSelectedEntries = () => {
    dispatch("releaseEntries")
  }

  let dataVertion = "new"
</script>

<!-- <svelte:window
  on:click={() => {
    if (showFilterForm) showFilterForm = false
  }}
/> -->
<div class="relative mx-auto w-full space-y-3">
  <div class="flex justify-between">
    <div class="flex w-full select-none justify-between text-lg font-bold text-black dark:text-white sm:text-2xl">
      <div class="flex items-center gap-3">
        <span class="block lg:hidden">{@html title}</span>
        <span class="hidden lg:block">{title.replace("<br/>", " ")}</span>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- <div class="flex items-center justify-start rounded-full bg-[#f7f7f7] p-1 dark:bg-darkgray">
          <div on:click={() => (dataVertion = "new")} class="w-9 rounded-full {dataVertion == 'new' ? 'bg-blue-500 text-white' : 'bg-none'} text-center text-xs">New</div>
          <div on:click={() => (dataVertion = "old")} class="w-9 rounded-full {dataVertion == 'old' ? 'bg-blue-500 text-white' : 'bg-none'} text-center text-xs">Old</div>
        </div> -->
      </div>
      <!-- {#if colorInfo}
        <div class="flex cursor-pointer items-center gap-3">
          <div data-tooltip="Completed" tooltip-position="top" class="h-5 w-5 rounded-full bg-green-500" />
          <div data-tooltip="Pending" tooltip-position="top" class="h-5 w-5 rounded-full bg-yellow-500" />
          <div data-tooltip="Revoked" tooltip-position="top" class="h-5 w-5 rounded-full bg-red-500" />
        </div>
      {/if} -->
    </div>
  </div>

  <!-- Table header -->
  <div class="flex w-full items-center justify-between gap-1.5 mobile:gap-3">
    <!-- Select entries dropdown & Sort -->
    <div class="flex w-full items-center justify-between gap-3">
      <div class="flex w-full items-center gap-1.5 mobile:gap-3">
        <span class="hidden min-w-fit select-none text-sm font-medium text-gray-200 mobile:block md:text-base">Displayed entries</span>
        <span class="block min-w-fit select-none text-sm font-medium text-gray-200 mobile:hidden md:text-base">Entries</span>
        <!-- dropdown -->
        {#if !searched}
          <div>
            <Dropdown
              dropdownItems={entriesList}
              selected={entries}
              on:itemSelect={(e) => {
                entries = e.detail
                activePage = 1
                // listEntries(entries)
                 console.log("Dropdown");
                dispatch("changeEntries", { filter: filterParameters, entries: entries, activePage: activePage, sort: sort ? 1 : -1, sortBy: sortBy })
              }}
            />
          </div>
        {:else}
          <span class="select-none font-mono font-bold text-blue-500">{sortData.length}</span>
        {/if}
      </div>

      <!-- Sort list buttons -->
      <div class="flex gap-1.5 mobile:gap-3">
        {#if showReleaseBtn}
          <div data-tooltip="Select All Entries" tooltip-position="left" class="flex h-9 min-h-full w-9 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium focus:outline-none dark:bg-darkgray">
            <input
              title={disableGroupCheckBox ? "Can't Select more than 100 documents" : ""}
              disabled={disableGroupCheckBox}
              on:input={() => {
                $ReleaseData.selectChecked = !$ReleaseData.selectChecked
                dispatch("groupSelect")
              }}
              bind:checked={$ReleaseData.selectChecked}
              name="group-check"
              type="checkbox"
              style="color-scheme:{$ApplicationState.darkMode ? 'dark' : ''}"
              class="h-4 w-4 cursor-pointer disabled:cursor-not-allowed"
            />
          </div>
          <button disabled={!$ReleaseData.selected.length && !$ReleaseData.previouslySelected.length} data-tooltip="Release Selected Documents" tooltip-position="left" type="button" on:click={releaseSelectedEntries} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-red-500 hover:text-white focus:outline-none active:bg-red-600 active:text-white disabled:cursor-not-allowed dark:bg-darkgray dark:text-slate-200 dark:hover:bg-red-500">
            <i class="fa-solid fa-trash-can" />
          </button>
        {/if}
        <!-- <div class="absolute right-[144px] top-11 z-10 lg:right-[145px]"> -->
        {#if filetemplate}
          <div data-tooltip={$ApplicationState.fileListToggle ? "Card View" : "List view"} tooltip-position="left">
            <div class="hidden md:block">
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <button
                on:click={() => {
                  $ApplicationState.fileListToggle = !$ApplicationState.fileListToggle
                  entries = !$ApplicationState.fileListToggle ? 12 : 10
                  entriesList = !$ApplicationState.fileListToggle ? [12, 60, 120] : [10, 50, 100]
                  dispatch("listTypeChanged")
                }}
                type="button"
                class="flex h-9 w-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-white text-gray-800 hover:bg-yellow-500 hover:text-white active:bg-white active:text-yellow-500 dark:bg-darkgray dark:text-slate-200 dark:hover:bg-yellow-500"
              >
                <i class="fa-solid {$ApplicationState.fileListToggle ? 'fa-tv' : 'fa-list'}" />
              </button>
            </div>
          </div>
        {/if}

        {#if Object.keys(infoDetails).length}
          <!-- View Info -->
          <div class="relative select-none">
            <button
              data-tooltip="View Info"
              tooltip-position="left"
              type="button"
              on:click={() => {
                showInfo = !showInfo
              }}
              class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:border-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 active:text-white disabled:cursor-not-allowed dark:border-[#a0a1a580] dark:bg-darkgray dark:text-slate-200 dark:hover:border-blue-600 dark:hover:bg-blue-600 dark:active:bg-blue-500"
            >
              <i class="fa-solid fa-info" />
            </button>

            {#if showInfo}
              <!-- svelte-ignore a11y-click-events-have-key-events -->
              <div
                on:click|stopPropagation={() => {
                  showInfo = true
                }}
              >
                <form on:submit|preventDefault|stopPropagation={filterList} class="absolute right-0 top-10 z-20 w-fit space-y-3 rounded-md border border-[#a0a1a580] bg-white px-4 py-3 shadow-md dark:bg-darkgray mobile:w-auto">
                  {#each Object.entries(infoDetails) as [key, value]}
                    <div class="flex items-center gap-3">
                      <div class="h-4 w-4 rounded-full {value}" />
                      <h1 class="text-sm text-black dark:text-white">{key}</h1>
                    </div>
                  {/each}
                </form>
              </div>
            {/if}
          </div>
        {/if}

        <!-- </div> -->
        {#if dateSort}
          <!-- Date sort -->
          <button disabled={!sortData.length} data-tooltip={sortByDateFile ? "Sort by Date, Newest First" : "Sort by Date, Oldest First"} tooltip-position="left" type="button" on:click={toggleSortByDate} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border px-2 text-sm font-medium hover:border-blue-600 hover:bg-blue-600 active:bg-blue-500 dark:hover:border-blue-600 dark:hover:bg-blue-600 dark:active:bg-blue-500 {(query && query.sortBy == 'date') || !nameSort ? 'border-blue-500 bg-blue-500 text-white' : 'border-[#a0a1a580] bg-white text-gray-800  dark:border-[#a0a1a580] dark:bg-darkgray dark:text-slate-200'}  hover:text-white focus:outline-none active:text-white disabled:cursor-not-allowed">
            <!-- <i class="fa-solid {!sortByDateFile ? ' fa-arrow-up-1-9' : ' fa-arrow-down-1-9'}" /> -->
            <i class="fa-solid {sortByDateFile ? 'fa-calendar-arrow-up' : ' fa-calendar-arrow-down'}" />
            <!-- <i class="fa-solid fa-calendar-arrow-up" /> -->
          </button>
        {/if}

        <!-- Name sort -->
        <button disabled={!sortData.length || !nameSort} data-tooltip={!sortByNameFile ? "Sort by Name in Ascending order" : "Sort by Name in Descending  order"} tooltip-position="left" type="button" on:click={toggleSortByName} class="ark:hover:border-blue-600 flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border px-2 text-sm font-medium hover:border-blue-600 hover:bg-blue-600 active:bg-blue-500 dark:hover:border-blue-600 dark:hover:bg-blue-600 dark:active:bg-blue-500 {query && query.sortBy == 'name' ? 'border-blue-500 bg-blue-500 text-white' : 'border-[#a0a1a580] bg-white text-gray-800 dark:border-[#a0a1a580] dark:bg-darkgray dark:text-slate-200  dark:hover:border-[#a0a1a580]'} hover:text-white focus:outline-none active:text-white disabled:cursor-not-allowed">
          <i class="fa-solid {!sortByNameFile ? 'fa-arrow-up-a-z' : 'fa-arrow-down-a-z'} " />
        </button>
      </div>
    </div>

    <!-- filter section -->
    {#if filter}
      <div class="select-none">
        <button data-tooltip="Search and Filter" tooltip-position="left" type="button" on:click|stopPropagation={() => (showFilterForm = !showFilterForm)} class="flex h-9 min-h-full w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-800 hover:bg-green-500 hover:text-white focus:outline-none active:bg-green-600 active:text-white dark:bg-darkgray dark:text-slate-200 dark:hover:bg-green-500">
          <i class="fa-solid fa-filter" />
        </button>
        <!-- <button on:click={() => (showFilterForm = !showFilterForm)} class="flex h-9 w-max min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 p-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4">
          <span class="hidden sm:block">Search and Filter</span>
          <i class="fa-solid fa-filter block sm:hidden" />
        </button> -->

        {#if showFilterForm}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div on:click|stopPropagation={() => (showFilterForm = true)}>
            <svelte:component this={filterComponent} bind:showFilterForm on:callFilter={filterList} {search} {status} {bulkStatus} {mode} {searchparam} />
          </div>
        {/if}
      </div>
    {/if}
  </div>

  <slot />

  <!-- Table footer  -->
  {#if !searched && sortData.length}
    <div class="test-sm flex w-full select-none flex-col items-center justify-between gap-3 sm:flex-row sm:gap-0 sm:text-base">
      <!-- How many entries shows in total entries -->
      <p class="font-medium text-gray-200">
        Showing {activePage * entries - entries + 1} to {activePage * entries > count ? count : activePage * entries} of
        <span class="font-mono font-bold text-blue-500">{count}</span>
        entries
      </p>

      <Pagination
        {maxPage}
        bind:activePage
        on:pageNo={() => {
          console.log("Pagination");
          dispatch("changeEntries", { filter: filterParameters, entries: entries, activePage: activePage, sort: sort ? 1 : -1, sortBy: sortBy })
        }}
      />
    </div>
  {:else}
    <div class="flex select-none items-center justify-between pb-6">
      <p class="font-medium text-gray-200">
        There are
        <span class="font-mono font-bold text-blue-500">{sortData.length}</span>
        entries found
      </p>
      <button
        on:click={() => {
          // sortData = []
          // listEntries(10)
          filterParameters = {
            search: {
              searchParam: "name",
            },
            date: {},
          }
          searched = false
          activePage = 1
          entries = entriesList[0]
          dispatch("resetEntries")
        }}
        class="float-right flex h-9 w-32 min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-300 lg:px-4"
      >
        <i class="fa-solid fa-rotate-left" />
        &nbsp;&nbsp;Reset
      </button>
    </div>
  {/if}
</div>
